var map = {
	"./app_icon.svg": 49852,
	"./bowl.svg": 75129,
	"./cup.svg": 265,
	"./download.svg": 39007,
	"./items_icon.svg": 37867,
	"./monitoring_icon.svg": 46942,
	"./pdf_icon.svg": 64824,
	"./qr-code.png": 98482,
	"./relevo_logo.svg": 57620,
	"./reports_icon.svg": 91586,
	"./restaurant_icon.svg": 27104,
	"./rpp_icon.svg": 51258,
	"./settings_icon.svg": 60116,
	"./user_icon.svg": 26065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;